export default new (class Scroll {
    constructor() {
        this.initHandler()
    }

    /**
     * @description Init handler.
     */
    initHandler() {
        window.addEventListener("load", () => {
            /*var url_string = window.location.href;
            var url = new URL(url_string);
            var c = url.searchParams.get("scroll");*/

            /*if(c && document.querySelector(`._js-scroll-content[data-scroll="${c}"]`)) {
                setTimeout(() => {
                    this.onScrollById(c);
                }, 500);
            }*/

            document.querySelectorAll(`._js-scroll-item`).forEach((item) => {
                item.addEventListener('click', (e) => {
                    let id = item.getAttribute('data-scroll')
                    if(document.querySelector(`._js-scroll-content[data-scroll="${id}"]`)) {
                        e.preventDefault();
                        this.onScrollById(id);
                    }
                });
            });
        });
    }

    onScrollById(id) {
        let offset = 70;

        if(window.innerWidth < 768) {
            offset = 56;
        }

        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = document.querySelector(`._js-scroll-content[data-scroll="${id}"]`).getBoundingClientRect().top;
        const elementPosition = elementRect - bodyRect;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }

})()
